import Nav from "./components/Nav";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Project from "./pages/Project";
import { Routes, Route } from "react-router-dom";
import Projects from "./pages/Projects";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Contact from "./pages/Contact";
import ContactSucess from "./pages/ContactSucess";
function App() {
  return (
    <div className="min-h-full">
      <Nav />
      <div className="py-10">
        <main>
          <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services" element={<Services />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:id" element={<Project />} key=":id" />1
              <Route
                path="/projects/:id/privacy-policy"
                element={<PrivacyPolicy />}
                key=":id"
              />
              <Route path="/contact/sucess" element={<ContactSucess />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </div>
        </main>
      </div>
    </div>
  );
}

export default App;
